import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../../components/Inputs/ResourceSelect";
import { renderSettingsResourceLabel } from "../../../../../../utils/helpers/settings";
import { getSettingsResourceSearchFilters } from "../../../../../../utils/helpers/settings";

export const useCalculationGroupFilter = () => {
    const { t } = useTranslation();

    return useMemo(() => ({
        name: "calculationGroup",
        label: t("calculation-group"),
        type: "resource-select",
        component: (
            <ResourceSelect
                labelPropName="description"
                renderLabel={renderSettingsResourceLabel}
                resourcePath="/calculation-group"
                hasSearch
                mode="multiple"
                getSearchFilters={getSettingsResourceSearchFilters}
            />
        ),
    }), [t]);
}